// imports
import styled from 'styled-components';

// styling
const SectionWrapper = styled.section`
  width: 100%;
  padding: 70px 0;
`;

// exports
export const CounterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const CounterItem = styled.div`
  margin: 5px;
  height: 120px;
  display: flex;
  flex: 1 0 30%;

  color: #45a4f7;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-family: Open Sans, sans-serif;

  border-radius: 5px;
  box-shadow: -2px 2px 6px 0px rgba(100, 167, 255, 0.12);

  &.iconItem {
    &::before {
      top: 6px;
      left: 70px;
      height: 0px;
      content: '↑';
      font-size: 40px;
      font-weight: 600;
      position: relative;
      
      animation-duration: 0.9s;
      animation-name: arrowPulse;
      animation-timing-function: ease;
      animation-iteration-count: infinite;

      @media only screen and (max-width: 1219px) {
        top: 12px;
        left: 60px;
        font-size: 32px;
      }
    }

    &::after {
      height: 0px;
      content: '%';
      bottom: 75px;
      right: -32px;
      font-size: 20px;
      font-weight: 700;
      position: relative;

      @media only screen and (max-width: 1219px) {
        bottom: 78px;
        right: -29px;
      }
    }

    @keyframes arrowPulse {
      0% {transform: none;}
      25% {transform: translateY(2px);}
      50% {transform: none;}
      75% {transform: translateY(-2px);}
      100% {transform: none;}
    }
  }

  @media only screen and (max-width: 991px) {
    flex: 1 0 40%;
  }

  @media only screen and (max-width: 667px) {
    flex: 1 0 50%;
  }

  h3 {
    font-size: 36px;
    font-weight: 600;
    margin-top: 20px;
    line-height: 30px;

    @media only screen and (max-width: 1219px) {
      font-size: 28px;
    }
  }

  p {
    color: #43414e;
    font-size: 18px;
    font-weight: 100;
    line-height: 20px;
  }
`;

export default SectionWrapper;